import BatteryFullIcon from '@/shared/assets/icons/batteryFull.svg?react'
import BatteryHalfIcon from '@/shared/assets/icons/batteryHalf.svg?react'
import BatteryEmptyIcon from '@/shared/assets/icons/batteryEmpty.svg?react'

type Props = {
  battery: null | number
}

export const BatteryIcon = ({ battery }: Props) => {
  if (battery === null || battery <= 20) {
    return <BatteryEmptyIcon />
  } else if (battery > 20 && battery < 75) {
    return <BatteryHalfIcon />
  } else if (battery >= 75) {
    return <BatteryFullIcon />
  }
}
